import { z } from "zod";

export const manualSyncRequestSchema = z
  .object({
    shopIds: z
      .array(z.string().uuid())
      .min(1)
      .max(50)
      .refine((ids) => new Set(ids).size === ids.length, "Select each shop once"),
    startDate: z.string().date(),
    endDate: z.string().date(),
  })
  .strict()
  .superRefine((value, ctx) => {
    const today = Date.parse(`${new Date().toISOString().slice(0, 10)}T00:00:00Z`);
    const start = Date.parse(value.startDate);
    const end = Date.parse(value.endDate);
    if (end < start || end > today)
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["endDate"],
        message: "Select a completed date range ending within the supported window",
      });
    if (start < today - 61 * 86_400_000 || end - start >= 60 * 86_400_000)
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["startDate"],
        message: "Manual sync supports the latest 60 completed days",
      });
  });
export type ManualSyncRequest = z.infer<typeof manualSyncRequestSchema>;

export const manualSyncResponseSchema = z.object({
  results: z.array(
    z.object({
      shopId: z.string().uuid(),
      ads: z.object({
        status: z.enum(["queued", "busy", "failed"]),
        batchId: z.string().uuid().optional(),
        errorCode: z.string().optional(),
      }),
      sales: z.object({
        status: z.enum(["queued", "busy", "unavailable", "failed"]),
        runIds: z.array(z.string().uuid()).optional(),
        realtimeJobId: z.string().min(1).optional(),
        errorCode: z.string().optional(),
      }),
    }),
  ),
});
export type ManualSyncResponse = z.infer<typeof manualSyncResponseSchema>;
